import { h } from "snabbdom";
import { previewHost } from "../editor/preview";
import { PREVIEW_LINES } from "../preview-limits";
import type { VNode } from "snabbdom";
import type { CardSummary, Model, Msg } from "../types";

export function viewTopbar(model: Model, dispatch: (msg: Msg) => void): VNode {
  return h("header.topbar", [
    h(
      "button.topbar__home",
      { attrs: { title: "Home Card" }, on: { click: () => dispatch({ type: "GoHome" }) } },
      "⌂"
    ),
    viewSearch(model, dispatch),
    h(
      "button.topbar__tags" + (model.route === "tags" ? ".topbar__tags--active" : ""),
      { attrs: { title: "Manage tags" }, on: { click: () => dispatch({ type: "OpenTagsPage" }) } },
      "🏷"
    ),
    h(
      "button.topbar__settings" + (model.route === "settings" ? ".topbar__settings--active" : ""),
      {
        attrs: { title: "Settings" },
        on: { click: () => dispatch({ type: "OpenSettingsPage" }) },
      },
      "⚙"
    ),
    h(
      "button.topbar__plus",
      { attrs: { title: "New Card" }, on: { click: () => dispatch({ type: "OpenModal" }) } },
      "+"
    ),
  ]);
}

function viewSearch(model: Model, dispatch: (msg: Msg) => void): VNode {
  const onInput = (e: Event) => {
    dispatch({ type: "SearchQuery", query: (e.target as HTMLInputElement).value });
  };

  const onBlur = () => {
    setTimeout(() => dispatch({ type: "CloseSearch" }), 150);
  };

  const onKeydown = (e: KeyboardEvent) => {
    if (!model.searchDropdownOpen || model.searchResults.length === 0) return;
    if (e.key === "ArrowDown") {
      e.preventDefault();
      dispatch({ type: "MoveSearchSelection", delta: 1 });
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      dispatch({ type: "MoveSearchSelection", delta: -1 });
    } else if (e.key === "Enter") {
      e.preventDefault();
      const r = model.searchResults[model.searchSelected];
      if (r) {
        dispatch({ type: "CloseSearch" });
        dispatch({ type: "NavigateTo", id: r.id });
      }
    } else if (e.key === "Escape") {
      dispatch({ type: "CloseSearch" });
    }
  };

  return h("div.topbar__search-wrap", [
    h("input.topbar__search", {
      attrs: { type: "text", placeholder: "Search cards…" },
      // `value` as a prop (live .value property) so clearing searchQuery actually
      // resets a field the user has typed into — the attribute only sets defaultValue.
      props: { value: model.searchQuery },
      on: { input: onInput, blur: onBlur, keydown: onKeydown },
    }),
    ...(model.searchDropdownOpen && model.searchResults.length > 0
      ? [viewSearchDropdown(model.searchResults, model.searchSelected, dispatch)]
      : []),
  ]);
}

function viewSearchDropdown(
  results: CardSummary[],
  selected: number,
  dispatch: (msg: Msg) => void
): VNode {
  return h(
    "ul.search-dropdown",
    results.slice(0, 10).map((r, i) =>
      h(
        "li.search-dropdown__item",
        {
          class: { "search-dropdown__item--active": i === selected },
          on: {
            mousedown: () => {
              dispatch({ type: "CloseSearch" });
              dispatch({ type: "NavigateTo", id: r.id });
            },
          },
        },
        [previewHost(r.content, 1, dispatch, PREVIEW_LINES.search)]
      )
    )
  );
}
